module.exports = __webpack_public_path__ + "img/monthly-usage-tax-icon.031d5d8b.svg";